import { createBrowserHistory } from 'history'
import { persistStore } from 'redux-persist'

import initStore from './store'
import type { GlobalState } from './store'

export const history = createBrowserHistory()
export const store = initStore(history)
export const persistor = persistStore(store)

export type { GlobalState }
